module.exports = __webpack_public_path__ + "static/img/evolucao-convites-area.3ac3db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolucao-convites-area.png
// module id = JJPk
// module chunks = 1